@use '@dixa/lib-shared-tokens/scss' as *;

.controls {
  display: flex;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: var(--dixa-size-spacer-200);
}
